export const formatCash = (n: string) => {
  const v = Number(n)
  if (v < 1e3) return n
  if (v >= 1e3 && v < 1e6) return +(v / 1e3).toFixed(1) + "K"
  if (v >= 1e6 && v < 1e9) return +(v / 1e6).toFixed(1) + "M"
  if (v >= 1e9 && v < 1e12) return +(v / 1e9).toFixed(1) + "B"
  if (v >= 1e12) return +(v / 1e12).toFixed(1) + "T"
}
